import { registerLocaleData } from '@angular/common';

const resolve = async (locale: string) => {
  switch (locale) {
    case 'de':
      return import(
        /* webpackChunkName: "ng-locale-de" */
        '@angular/common/locales/de'
      );
    case 'nl':
      return import(
        /* webpackChunkName: "ng-locale-nl" */
        '@angular/common/locales/nl'
      );
    case 'fr':
      return import(
        /* webpackChunkName: "ng-locale-fr" */
        '@angular/common/locales/fr'
      );
    case 'sv':
      return import(
        /* webpackChunkName: "ng-locale-sv" */
        '@angular/common/locales/sv'
      );
    case 'fi':
      return import(
        /* webpackChunkName: "ng-locale-fi" */
        '@angular/common/locales/fi'
      );

    case 'en':
    default:
      return import(
        /* webpackPrefetch: true */
        /* webpackChunkName: "ng-locale-en" */
        '@angular/common/locales/en'
      );
  }
};

export const loadAngularTranslations = async (locale: string) =>
  resolve(locale).then(m => registerLocaleData(m.default));
